import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ReviewsSection.css";

const Reviews = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [reviews, setReviews] = useState([]);
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");

  // ✅ Backend se reviews fetch
  const fetchReviews = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/reviews?limit=10`);
      setReviews(res.data.reviews || []);
    } catch (err) {
      console.error("Error fetching reviews:", err);
    }
  };

  useEffect(() => {
    fetchReviews();
  }, []);

  // ✅ Submit handler (backend POST call)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !message || rating === 0) {
      return alert("Please fill all fields!");
    }

    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/reviews`, {
        userName: name,
        comment: message,
        rating,
      });

      // Add hone ke baad fresh list fetch
      fetchReviews();

      // Reset form
      setName("");
      setMessage("");
      setRating(0);
    } catch (err) {
      console.error("Error adding review:", err);
      alert("Failed to submit review");
    }
  };

  // ✅ Rating Distribution
  const getRatingCount = (star) =>
    reviews.filter((r) => r.rating === star).length;

  const totalReviews = reviews.length;

  // ✅ Average Rating
  const avgRating =
    totalReviews === 0
      ? 0
      : (reviews.reduce((acc, r) => acc + r.rating, 0) / totalReviews).toFixed(
          1
        );

  return (
    <section id="reviews-section-unique">
      <h2 className="reviews-heading">User Reviews</h2>

      <div className="reviews-container">
        {/* LEFT SIDE - Review Form + Auto-Scroll Reviews */}
        <div className="left-section">
          {/* Review Form */}
          <form className="review-form" onSubmit={handleSubmit}>
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <textarea
              placeholder="Write your review..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            {/* ⭐ Star Rating */}
            <div className="star-rating">
              {[...Array(5)].map((_, index) => {
                const starValue = index + 1;
                return (
                  <span
                    key={starValue}
                    className={`star ${
                      starValue <= (hover || rating) ? "filled" : "empty"
                    }`}
                    onClick={() => setRating(starValue)}
                    onMouseEnter={() => setHover(starValue)}
                    onMouseLeave={() => setHover(0)}
                  >
                    ★
                  </span>
                );
              })}
            </div>

            <button type="submit">Submit Review</button>
          </form>

          {/* Reviews Display (Auto scroll slider style) */}
          <div className="reviews-slider">
            {reviews.length === 0 ? (
              <p className="no-reviews">
                No reviews yet. Be the first to add one!
              </p>
            ) : (
              <div className="slider-wrapper">
                {reviews.map((review, i) => (
                  <div key={i} className="review-card">
                    <div className="review-user">
                      <div className="user-icon">
                        {review.userName
                          ? review.userName[0].toUpperCase()
                          : "U"}
                      </div>
                      <span className="user-name">
                        {review.userName || "Anonymous"}
                      </span>
                    </div>
                    <div className="star-rating">
                      {[...Array(5)].map((_, idx) => (
                        <span
                          key={idx}
                          className={`star ${
                            idx < review.rating ? "filled" : "empty"
                          }`}
                        >
                          ★
                        </span>
                      ))}
                    </div>
                    <p className="review-message">{review.comment}</p>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* RIGHT SIDE - Rating Summary + Avg Rating Circle */}
<div className="right-section">
  <h3>Rating Summary</h3>
  
  <div className="rating-summary">
    {[5, 4, 3, 2, 1].map((star) => {
      const count = getRatingCount(star);
      const percentage =
        totalReviews === 0 ? 0 : Math.round((count / totalReviews) * 100);

      return (
        <div key={star} className="rating-bar">
          <span className="star-label">{star} ★</span>
          <div className="bar">
            <div
              className="bar-fill"
              style={{ width: `${percentage}%` }}
            ></div>
          </div>
          <span className="count">{count}</span>
        </div>
      );
    })}
  </div>

  {/* ⭐ Average Rating Circle */}
{/* ⭐ Average Rating Circle */}
<div
  className="avg-rating-card"
  style={{
    "--percent":
      totalReviews === 0 ? 0 : ((avgRating / 5) * 100).toFixed(0),
  }}
>
  <div className="circle">
    <span className="rating-value">{avgRating}</span>
    <span className="outof">/5</span>
    <span className="circle-reviews">{totalReviews} Reviews</span>
  </div>
  <p className="avg-label">Average Rating</p>
</div>


</div>
</div>

    </section>
  );
};

export default Reviews;
